import { Divider } from '@geberit/gdds';

function Separator() {
  return <Divider />
}

export default Separator;
